import React, { useEffect } from 'react';
import { HeroSection } from '../components/landing/HeroSection';
import { PatternSection } from '../components/landing/PatternSection';
import { ProblemSection } from '../components/landing/ProblemSection';
import { SolutionSection } from '../components/landing/SolutionSection';
import { BenefitsSectionWithCheckout } from '../components/landing/BenefitsSectionWithCheckout';
import { FAQSection } from '../components/landing/FAQSection';
import { CTASectionWithCheckout } from '../components/landing/CTASectionWithCheckout';
import { PurchaseNotifier } from '../components/PurchaseNotifier';
import { ConsequencesSection, ProtocolIntroSection, ProgramIncludesSection, AuthorSection, WrittenTestimonialsSection } from '../components/landing/FunnelSections';
export function LandingPageCanino2() {
  useEffect(() => {
    document.title = '30 Recetas Naturales para Perros';
  }, []);
  const checkoutUrl = 'https://pay.hotmart.com/Y104256235W?off=mstmo7g1&checkoutMode=10&bid=1773273486617';
  return <main className="min-h-screen bg-gradient-to-b from-orange-50/20 to-yellow-50/20 font-sans text-gray-900" data-id="element-1719">
      <HeroSection data-id="element-1720" />
      <PatternSection hideAudio data-id="element-1721" />
      <ConsequencesSection data-id="element-1722" />
      <ProtocolIntroSection data-id="element-1723" />
      <ProgramIncludesSection data-id="element-1724" />
      <AuthorSection data-id="element-1725" />
      <WrittenTestimonialsSection data-id="element-1726" />
      <BenefitsSectionWithCheckout checkoutUrl={checkoutUrl} displayPrice="$69.999" data-id="element-1727" />
      <ProblemSection data-id="element-1728" />
      <SolutionSection data-id="element-1729" />
      <FAQSection data-id="element-1730" />
      <CTASectionWithCheckout checkoutUrl={checkoutUrl} displayPrice="$69.999" data-id="element-1731" />
      <footer className="bg-orange-50/30 py-12 border-t border-orange-100" data-id="element-1732">
        <div className="container mx-auto px-4 text-center" data-id="element-1733">
          <p className="text-gray-500 text-sm" data-id="element-1734">
            © {new Date().getFullYear()} Recetas Anti-Inflamación para Perros.
            Todos los derechos reservados.
          </p>
          <p className="text-gray-400 text-xs mt-2" data-id="element-1735">
            Este producto es una guía educativa y no sustituye el consejo
            veterinario profesional.
          </p>
        </div>
      </footer>
      <PurchaseNotifier enabled={true} displayPrice="$69.999 COP" data-id="element-1736" />
    </main>;
}